export const SHOWLOADING = 'SHOWLOADING';
export const HIDELOADING = 'HIDELOADING';


// WEBPACK FOOTER //
// ./src/store/modules/type.js